import React, { createContext, useState } from "react";

export const ApiContext = createContext(null);

const ApiContextProvider = (props) => {
  const { children } = props;

  const [apiContext, setApiContextState] = useState({
    autoToken: null
  });

  const setApiContext = (value) => {
    setApiContextState({...apiContext, ...value})
  }

  const value = {
    apiContext, setApiContext,
  }

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

export default ApiContextProvider;
